import { AbstractBaseLayerState } from '../../../../../../cross-team-shared/annotation/shared/state/layers/abstract-base-layer-state';
import { TransientRasterLayerState } from '../../../../../../outputs/annotation/annotation-shared/state/layers/transient-raster-layer-state';
import { AbstractLayerState } from './abstract-layer-state';

export class RasterLayerState
  extends AbstractBaseLayerState
  implements AbstractLayerState
{
  override readonly type = 'raster_coding';

  constructor(
    width: number,
    height: number,
    public transient: TransientRasterLayerState,
  ) {
    super(width, height);
  }
}
